import React from "react"
import PropTypes from "prop-types"
import cx from "classnames"
import { OldButton } from "@kit/design/old-button"
import Icon from "@kit/design/icon"
import { DismissButton } from "./dismiss-button"

/**
 * The footer variant of the App Discoverability CTA used in the VA and editor.
 */
export function AppDiscoverabilityButton({
  href = "/apps",
  className,
  onClick,
  onDismiss
}) {
  // Using a regular button link instead of core/link because this component is used by file
  // gallery which is used in functions.js which cannot use inertia.
  return (
    <div
      className={cx(
        "flex items-center justify-center gap-2 relative p-1 bg-gray-100",
        className
      )}
    >
      <DismissButton
        onDismiss={onDismiss}
        className="absolute"
        style={{ left: "0.25rem" }}
      />
      <OldButton
        href={href}
        is="tertiary"
        size="sm"
        className="gap-2"
        onClick={onClick}
      >
        Do more with apps
        <Icon name="arrow-right" />
      </OldButton>
    </div>
  )
}

AppDiscoverabilityButton.propTypes = {
  href: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired
}
